import apiClient from '@app/config/axios.config'
import { Endpoint } from '@app/config/endpoints'
import { LayerPermissionsResponse, UserRole } from '@app/types'
import { logger } from '@app/utils/logger'

const LayerPermissionsService = {
  getLayerPermissions: async (
    page: number,
    pageSize: number,
    layerType: string,
  ): Promise<LayerPermissionsResponse[]> => {
    try {
      const response = await apiClient.get<LayerPermissionsResponse[]>(
        `${Endpoint.layerPermissions}?page=${page}&page_size=${pageSize}&layer_type=${layerType}`,
      )
      return response.data
    } catch (error) {
      logger.error('Error fetching layer permissions:', error)
      throw error
    }
  },

  updateLayerPermissions: async (layerId: number, user_roles: UserRole[]): Promise<void> => {
    try {
      await apiClient.put<void>(`${Endpoint.layerPermissions}/${layerId}`, {
        user_roles,
      })
    } catch (error) {
      logger.error('Error updating layer permissions:', error)
      throw error
    }
  },
}

export { LayerPermissionsService }
